import { Injectable } from '@angular/core';
import { DcTypes, Feature, TypedFeatureProperties } from '../../../../projects/client';
import { DecimalPipeWrapper } from '../../../shared/pipes/decimal-pipe-wrapper/decimal-pipe-wrapper.pipe';
import {
  TransformedEnergyDetails,
  getTransformedEnergyDetailsFromFeature,
  isThisEnergyFeature,
} from '../../helpers/energy';
import { FeatureValueStrategy } from './feature-value-strategy.model';

@Injectable({ providedIn: 'root' })
// should be splitted to separate strategies for energyUnits and energyHoursUnits at some point
export class NumberValueEnergyUnitsStrategy implements FeatureValueStrategy {
  constructor(private decimalPipeWrapper: DecimalPipeWrapper) {}
  supports(
    feature: Feature<TypedFeatureProperties<number>, unknown>,
    propertyName: string
  ): boolean {
    const property = feature?.properties?.[propertyName];

    return property?.type === DcTypes.number && isThisEnergyFeature(property?.unit);
  }

  transformValue(
    feature: Feature<TypedFeatureProperties<number>, unknown>,
    propertyName: string,
    digitsInfo?: string
  ): string {
    const transformedEnergyDetails: TransformedEnergyDetails = getTransformedEnergyDetailsFromFeature(
      feature,
      propertyName
    );

    return this.decimalPipeWrapper.transform(transformedEnergyDetails?.value, digitsInfo);
  }
}
